export default "__VITE_ASSET__BtMDzUa8__"